import React from 'react';
import './Loader.css';

export default function Loader() {
  return (
    <div className="loading-masker">
      <div className="white-widget grey-bg author-area">
        <div className="auth-info row">
          <div className="timeline-wrapper">
            <div className="timeline-item">
              <div className="animated-background">
                <div className="background-masker header-top" />
                <div className="background-masker header-left" />
                <div className="background-masker header-right" />
                <div className="background-masker header-bottom" />
                <div className="background-masker subheader-left" />
                <div className="background-masker subheader-right" />
                <div className="background-masker subheader-bottom" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
